import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	&&& {
		.MuiCollapse-root.MuiCollapse-entered {
			overflow: hidden;
		}
	}
`;

export const TitleModal = styled.h6`
	font-weight: bold;
	font-size: 1.425rem;

	margin-bottom: 2rem;
`;
